import { SET_FILTER } from './actionTypes';

export const setFilter = (identifier = null, value = null) => {
	return {
		type: SET_FILTER,
		identifier: identifier,
		value: value,
	};
};
